<template>
  <div class="sucesso-atendimento">
    <div class="d-flex align-center justify-center py-8 bg-default">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">Atendimento finalizado</h4>
          <h5 class="secondary-font text--secondary mt-2">
            Atenção, seu atendimento foi finalizado, seus documentos já estão prontos
          </h5>
        </div>
      </v-container>
    </div>
    <div class="content container" :style="{ color: $vuetify.theme.themes.light.primary }">
      <div>
        <v-icon color="primary" size="80">mdi-check-decagram-outline</v-icon>
      </div>
      <div class="title">Parabéns</div>
      <div>Seu atendimento foi concluído com sucesso, a equipe Limer te deseja um excelente dia 😊</div>
      <!-- <div class="rating-area">
        <small class="black--text"> Avalie seu atendimento </small>
        <Rating @selected-rating="onSelectedRating" />
        <v-expand-transition>
          <v-alert type="error" :value="alertRating" outlined prominent dense>
            <small>Precisamos que você selecione uma nota para o seu atendimento</small>
          </v-alert>
        </v-expand-transition>
        <v-textarea
          class="my-3"
          placeholder="Ocorreu tudo bem? Sentiu falta de algo no seu atendimento?"
          v-model="observacoes"
          auto-grow
          rows="4"
          row-height="30"
          outlined
        ></v-textarea>
        <v-btn color="primary" :loading="loading" :disabled="loading" @click="submitReview()">Enviar avaliação</v-btn>
      </div> -->
    </div>
  </div>
</template>
<script>
import meetingService from '@/services/meeting'
// import Rating from '../../core/components/Rating.vue'
export default {
  name: 'SucessoAtendimento',
  data() {
    return {
      idAsoMeetingRoom: null,
      observacoes: null,
      selectedRating: false,
      alertRating: false,
      loading: false
    }
  },
  methods: {
    onSelectedRating(rating) {
      this.selectedRating = rating
    },
    async submitReview() {
      if (this.selectedRating !== undefined && this.selectedRating >= 0) {
        this.alertRating = false
        try {
          this.loading = true
          const params = {
            idAsoMeetingRoom: this.idAsoMeetingRoom,
            rating: this.selectedRating,
            observacoes: this.observacoes
          }
          await meetingService.reviewMeeting(params)
          this.$showSuccessMessage('Avaliação enviada com sucess')
          this.$router.push({ name: 'dashboard' })
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      } else {
        this.alertRating = true
      }
    }
  },
  created() {
    this.idAsoMeetingRoom = this.$route.query.id
    if (!this.idAsoMeetingRoom) {
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>
<style scoped>
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 10px; /* Rectangle 24 */
  background-color: #fff;
  margin-right: auto;
  margin-left: auto;
  margin-top: 5vh;
  width: 80vw;
  padding: 20px;
  gap: 20px;
}
.rating-area {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  text-align: center;
}
</style>
